<template lang="html">
    <div>
        <!-- Top bar-->
        <authority-header/>
        <!-- Begin Page Content -->
        <components v-bind:is="Content" v-on:change-view="goPage" :properties="properties" />
    </div>
</template>

<script>
    import Header from '@/views/Common/Header.vue'
    import Form from '@/views/Management/Authority/List.vue'    
	//import Create from '@/views/Management/User/Detail.vue'
	
    export default {
        name: 'Authority',
        components: 
        {
            'authority-header': Header,
            'authority-form': Form
        },
        created () {
            this.$axios.defaults.headers.common['x-access-token'] = this.$store.getters.getAccessToken;
            this.$axios.defaults.headers.common['x-refresh-token'] = this.$store.getters.getRefreshToken;
        },
        mounted(){
			//화면 새로고침시 기존 화면 불러오기
			if(this.$route.params.mid){
                this.goPage({'mid':this.$route.params.mid, 'type':this.$route.params.type});
			}else{
                this.goPage({'mid':sessionStorage.mid, 'type':sessionStorage.type});
			}
        },
        data () {
            return {
                Content: '',
                properties:[],
                menuHeaders:[]
            }
        },
        methods: {
            goPage(data){
                this.Content = 'authority-form';
                this.properties = data;
                sessionStorage.removeItem('type');
                sessionStorage.removeItem('mid');
                sessionStorage.setItem('type', data.type);
                sessionStorage.setItem('mid',data.mid);
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/Management/Authority/Authority.vue